export default __webpack_public_path__ + "static/media/course-2.08f77225.jpeg";